import { render, staticRenderFns } from "./CollectionPRO.vue?vue&type=template&id=0286e429&scoped=true&"
import script from "./CollectionPRO.vue?vue&type=script&lang=js&"
export * from "./CollectionPRO.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPRO.vue?vue&type=style&index=0&id=0286e429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286e429",
  null
  
)

export default component.exports